import { Company } from '@backend/domain'
import { Injectable } from '@nestjs/common'
import { InjectRepository } from '@nestjs/typeorm'
import { Repository } from 'typeorm'
import { SoftDeleteEntityRepository } from './generic'

@Injectable()
export class CompanyRepository extends SoftDeleteEntityRepository<Company> {
	constructor(@InjectRepository(Company) override readonly _repository: Repository<Company>) {
		super(_repository)
	}
}
